// extracted by css-extract-rspack-plugin
export default {"row":"pFe8ogaOikVAIbkg"};